<!-- <div class="p-col-12">
<p-steps [model]="dataSubmitSteps" [activeIndex]="activeIndex"></p-steps>
</div> -->
<p-card>
  <ng-template pTemplate="title"> Submit your study and data </ng-template>
  <ng-template pTemplate="subtitle">
    Please review your data carefully
  </ng-template>
  <ng-template pTemplate="content">
    <div class="flex flex-column">
      <!-- show warning if there are any issues with the submission isSubmissionComplete() -->
      @if (!isSubmissionComplete()) {
        <div>
          <p-message [icon]="this.validationWarnMessage.icon" [severity]="$any(this.validationWarnMessage.severity)" [closable]="false" class="w-full">
            <span class="strong">{{ this.validationWarnMessage.summary }}:</span>&nbsp;<span>{{ this.validationWarnMessage.detail }}</span>
          </p-message>
        </div>
      }
      @if (isSubmissionComplete()) {
        <div>
          <p-message [icon]="this.validationSuccessMessage.icon" [severity]="$any(this.validationSuccessMessage.severity)" [closable]="false" class="w-full">
            <span class="strong">{{ this.validationSuccessMessage.summary }}:</span>&nbsp;<span>{{ this.validationSuccessMessage.detail }}</span>
          </p-message>
        </div>
      }
      <div>
        <div class="p-card-title">Files in submission</div>
        <div style="overflow-x: auto; min-width: 0;">
        <p-table class="w-full" [value]="submission?.submittedFiles" id="summarySubmittedFiles"
          responsiveLayout="stack" [paginator]="true" [rows]="10">
          <ng-template pTemplate="header">
            <tr>
              <th>File Name</th>
              <th>File Type</th>
              <th>License</th>
              <th>SHA-256 Hash</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-submittedFile>
            <tr>
              <td><span class="p-column-title">File Name</span><p-button label="{{ submittedFile.fileName }}" [link]="true" (onClick)="downloadFile(submission.id, submittedFile)"></p-button></td>
              <td><span class="p-column-title">File Type</span>{{ submittedFile.fileType }}</td>
              <td><span class="p-column-title">License</span>{{ submittedFile.dataLicense?.licenseName }} ({{ 'LICENSES.' + (submittedFile.dataLicense?.licenseId ?? '') | uppercase | translate }})</td>
              <td><span class="p-column-title">SHA-256 Hash</span>{{ submittedFile.sha256Hash }}</td>
            </tr>
          </ng-template>
        </p-table>
        </div>
      </div>
      <div>
        <!-- use dataView over mzTabMResults with dataset-card in ng-template -->
        <p-dataview #summarySubmittedMzTabMFiles class="w-full" [value]="mzTabMResults | async" [paginator]="true"
          [rows]="10" layout="grid">
          <ng-template #header>
            <div>MzTab-M Results</div>
          </ng-template>
          <ng-template #grid let-mzTabMResults>
            <div class="flex flex-row flex-wrap gap-4">
              @for (mzTabResult of mzTabMResults; track mzTabResult) {
                <div class="w-full md:w-6 lg:w-6 xl:w-6 p-2">
                  <app-dataset-card [mzTabResult]="mzTabResult" [detailView]="datasetCardDetailView"
                    [showClassifications]="datasetCardShowClassifications" [showDatasetLink]="datasetCardShowDatasetLink"
                    [showPlots]="datasetCardShowPlots" [toggleable]="datasetCardToggleable"
                  ></app-dataset-card>
                </div>
              }
            </div>
          </ng-template>
        </p-dataview>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    @if (submission) {
      <div class="flex justify-between flex-wrap flex-row">
        <div class="flex">
          <button pButton type="button" label="Back" (click)="previousPage($event)" icon="fa fa-chevron-left"
          iconPos="left"></button>
        </div>
        <div class="flex">
          <span class="p-buttonset">
            <button pButton type="button" label="Cancel" (click)="cancel($event)" icon="fa fa-times" iconPos="right"
            class="p-button-danger"></button>
            <button pButton type="button" label="Submit" (click)="nextPage($event)" icon="fas fa-cloud-upload-alt"
            iconPos="right" class="p-button-success" [disabled]="!isSubmissionComplete()"></button>
          </span>
        </div>
      </div>
    }
  </ng-template>
</p-card>
